var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_13169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8.25C3 8.93944 3.1358 9.62213 3.39963 10.2591C3.66347 10.896 4.05018 11.4748 4.53769 11.9623C5.0252 12.4498 5.60395 12.8365 6.24091 13.1004C6.87787 13.3642 7.56056 13.5 8.25 13.5C8.93944 13.5 9.62213 13.3642 10.2591 13.1004C10.896 12.8365 11.4748 12.4498 11.9623 11.9623C12.4498 11.4748 12.8365 10.896 13.1004 10.2591C13.3642 9.62213 13.5 8.93944 13.5 8.25C13.5 7.56056 13.3642 6.87787 13.1004 6.24091C12.8365 5.60395 12.4498 5.0252 11.9623 4.53769C11.4748 4.05018 10.896 3.66347 10.2591 3.39963C9.62213 3.1358 8.93944 3 8.25 3C7.56056 3 6.87787 3.1358 6.24091 3.39963C5.60395 3.66347 5.0252 4.05018 4.53769 4.53769C4.05018 5.0252 3.66347 5.60395 3.39963 6.24091C3.1358 6.87787 3 7.56056 3 8.25Z",
    stroke: "#8790A1",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 15.25L12 12",
    stroke: "#8790A1",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_13169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.ee0ad49771d778db6306a7513e6cf81c.svg";
export { ForwardRef as ReactComponent };